'use client'

import Link from "next/link"
import { Poppins } from "next/font/google"

import { useCurrentBranch } from "@/context/current-branch-provider"
import ButtonLink from "@/components/system/button-link"

const poppins = Poppins({
    subsets: ['latin'],
    weight: ['300', '400', '500', '600', '700'],
})

export function DefaultFooter() {

    const { brand } = useCurrentBranch()

    const date = new Date()

    return (
        <section className={`bg-[#080808] ${poppins.className}`}>
            <div className="container mx-auto px-8 py-20 flex flex-col items-center justify-center text-center text-white">
                <Link href="https://popadvise.com" className="flex justify-center md:justify-start mb-6 md:mb-10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="244.073" height="52.042" viewBox="0 0 244.073 52.042">
                        <defs>
                            <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                <stop offset="0" stopColor="#4d3292" />
                                <stop offset="0" stopColor="#6989f8" />
                                <stop offset="0.931" stopColor="#6c59f4" />
                                <stop offset="0.97" stopColor="#6c57f4" />
                                <stop offset="1" stopColor="#6c56f4" />
                            </linearGradient>
                        </defs>
                        <path d="M84.382,31.621A26.019,26.019,0,0,1,58.361,57.642c-.3,0-.593,0-.884-.014a26.738,26.738,0,0,1-2.766-.24A26.023,26.023,0,1,1,84.382,31.621Z"
                            transform="translate(-32.34 -5.6)" fill="url(#linear-gradient)" />
                        <path d="M85.007,30.447c-2.141-7.73-10.731-12.688-18.334-9.564C60.8,23,57.565,30.857,59.711,36.469c.979,2.559,3.4,5.335,5.777,6.107v5.137a16.212,16.212,0,0,1-9.216-5.984c-.626-.739-1.2-2.075-1.905-2.475a1.117,1.117,0,0,0-1.684.739c-.565,1.727,2.978,5.471,4.309,6.652A17.458,17.458,0,0,0,62.3,49.7a18.027,18.027,0,0,0,3.147,1.021v14.26a26.74,26.74,0,0,0,2.766.24V50.9C79.211,51.195,87.947,40.59,85.007,30.447ZM67.713,36.2c-.2-3.147,1.068-6.229,4.77-5.1,2.216.677,2.508,4.159,1.609,6.022-1.059,2.2-3.825,2.526-5.151,2.522C67.713,39.635,67.944,39.8,67.713,36.2Zm3.514,11.86a16.083,16.083,0,0,1-3.044.047V42.458c5.81-.3,8.313-2.428,8.986-5.81.852-5.208-2.682-9.494-8.092-8.148-4.192,1.482-4.1,5.645-3.9,9.362-.019.673.136,1.51-.056,1.52-.423.014-2.776-1.407-3.176-5.514-.56-5.758,2.691-11.042,9.423-11.042a11.311,11.311,0,0,1,9.809,5.74C85.835,36.784,80.1,46.476,71.227,48.057Z"
                            transform="translate(-43.08 -13.191)" fill="#fff" />
                        <g transform="translate(61.898 7.587)" fill="currentColor">
                            <path d="M163.049,58.48c-1.379,1.329-3.482,2-6.307,2h-4.659V70.591H148.92V46.37h7.821q4.1,0,6.24,1.976a6.652,6.652,0,0,1,2.136,5.1A6.772,6.772,0,0,1,163.049,58.48Zm-2.422-1.758a4.208,4.208,0,0,0,1.253-3.263q0-4.478-5.138-4.482h-4.659v8.9h4.659A5.643,5.643,0,0,0,160.627,56.723Z"
                                transform="translate(-148.92 -42.745)" />
                            <path d="M176.072,70.6a8.638,8.638,0,0,1-3.406-3.456,10.6,10.6,0,0,1-1.236-5.2,10.232,10.232,0,0,1,1.27-5.155,8.716,8.716,0,0,1,3.456-3.44,10.662,10.662,0,0,1,9.806,0,8.728,8.728,0,0,1,3.456,3.423,11.106,11.106,0,0,1-.034,10.378,8.979,8.979,0,0,1-3.524,3.456,10.152,10.152,0,0,1-4.937,1.219A9.834,9.834,0,0,1,176.072,70.6Zm8.048-2.363a6.065,6.065,0,0,0,2.414-2.4,7.688,7.688,0,0,0,.917-3.894,7.864,7.864,0,0,0-.9-3.894,5.906,5.906,0,0,0-2.363-2.38,6.817,6.817,0,0,0-6.341,0,5.745,5.745,0,0,0-2.313,2.38,8.05,8.05,0,0,0-.866,3.894,8.319,8.319,0,0,0,.849,3.927,5.624,5.624,0,0,0,2.279,2.38,6.4,6.4,0,0,0,3.128.782A6.624,6.624,0,0,0,184.121,68.24Z"
                                transform="translate(-152.499 -43.666)" />
                            <path d="M205.243,53.243a8.34,8.34,0,0,1,4.323-1.093,8.835,8.835,0,0,1,4.6,1.219,8.5,8.5,0,0,1,3.246,3.423,10.66,10.66,0,0,1,1.186,5.122,10.87,10.87,0,0,1-1.186,5.138,8.666,8.666,0,0,1-7.846,4.76,8.259,8.259,0,0,1-4.289-1.093,7.891,7.891,0,0,1-2.834-2.725V80.534H199.28V52.461h3.162v3.507A7.652,7.652,0,0,1,205.243,53.243Zm9.259,4.92a6,6,0,0,0-2.346-2.43,6.5,6.5,0,0,0-3.246-.833,6.35,6.35,0,0,0-3.213.849,6.185,6.185,0,0,0-2.363,2.464,8.407,8.407,0,0,0,0,7.5,6.185,6.185,0,0,0,2.363,2.464,6.267,6.267,0,0,0,3.213.849,6.428,6.428,0,0,0,3.246-.849,6.091,6.091,0,0,0,2.346-2.464,7.9,7.9,0,0,0,.866-3.8A7.629,7.629,0,0,0,214.5,58.163Z"
                                transform="translate(-156.928 -43.665)" />
                            <path d="M226.317,56.473A8.333,8.333,0,0,1,229.395,53a8.043,8.043,0,0,1,4.34-1.219,7.506,7.506,0,0,1,3.6.833,6.126,6.126,0,0,1,2.38,2.187V52.058h5.946V71.442h-5.946V68.7a6.474,6.474,0,0,1-2.414,2.187,7.482,7.482,0,0,1-3.6.833,7.863,7.863,0,0,1-4.306-1.236,8.6,8.6,0,0,1-3.078-3.507,12.8,12.8,0,0,1,0-10.5Zm12.161,1.766a4.165,4.165,0,0,0-6-.017,4.8,4.8,0,0,0-1.236,3.49,4.906,4.906,0,0,0,1.236,3.524,4.128,4.128,0,0,0,6,.017,5.592,5.592,0,0,0,0-7.014Z"
                                transform="translate(-161.048 -43.606)" />
                            <path d="M254.375,55.329a8.333,8.333,0,0,1,3.078-3.473,8.043,8.043,0,0,1,4.34-1.219,7.663,7.663,0,0,1,3.49.8,6.337,6.337,0,0,1,2.481,2.153v-9h5.946V70.3h-5.946V67.516a6.075,6.075,0,0,1-2.38,2.22,7.483,7.483,0,0,1-3.6.833,7.914,7.914,0,0,1-4.34-1.236,8.6,8.6,0,0,1-3.078-3.507,11.633,11.633,0,0,1-1.127-5.265A11.514,11.514,0,0,1,254.375,55.329ZM266.536,57.1a4.165,4.165,0,0,0-6-.017,4.8,4.8,0,0,0-1.236,3.49,4.906,4.906,0,0,0,1.236,3.524,4.128,4.128,0,0,0,6,.017,4.85,4.85,0,0,0,1.236-3.507A4.9,4.9,0,0,0,266.536,57.1Z"
                                transform="translate(-165.508 -42.462)" />
                            <path d="M291.073,65.936l4.2-13.826H301.6l-6.879,19.385h-7.333L280.51,52.11h6.358Z"
                                transform="translate(-169.844 -43.658)" />
                            <path d="M308.892,47.577A2.971,2.971,0,0,1,307.9,45.3a3.017,3.017,0,0,1,.992-2.313,3.949,3.949,0,0,1,5.08,0,3.046,3.046,0,0,1,.992,2.313,2.983,2.983,0,0,1-.992,2.279,3.556,3.556,0,0,1-2.523.917A3.612,3.612,0,0,1,308.892,47.577Zm5.509,2.935V69.9h-5.946V50.512Z"
                                transform="translate(-174.199 -42.06)" />
                            <path d="M323.925,70.852a7.721,7.721,0,0,1-3.128-2.38,6.256,6.256,0,0,1-1.287-3.389h5.87a2.217,2.217,0,0,0,.942,1.632,3.29,3.29,0,0,0,2.052.622A2.921,2.921,0,0,0,330.1,66.9a1.324,1.324,0,0,0,.605-1.127,1.306,1.306,0,0,0-.866-1.236,16.76,16.76,0,0,0-2.817-.883,26.588,26.588,0,0,1-3.473-1.026,6.058,6.058,0,0,1-2.4-1.7,4.633,4.633,0,0,1-1.009-3.145,5.356,5.356,0,0,1,.917-3.044,6.151,6.151,0,0,1,2.708-2.17,10.441,10.441,0,0,1,4.255-.8,8.557,8.557,0,0,1,5.752,1.808,7.015,7.015,0,0,1,2.414,4.794H330.7a2.369,2.369,0,0,0-.883-1.6,3.056,3.056,0,0,0-1.96-.589,2.749,2.749,0,0,0-1.6.4,1.279,1.279,0,0,0-.555,1.093,1.339,1.339,0,0,0,.883,1.253,14.178,14.178,0,0,0,2.767.833,29.26,29.26,0,0,1,3.507,1.093,6.1,6.1,0,0,1,2.38,1.741,4.947,4.947,0,0,1,1.06,3.213,5.1,5.1,0,0,1-.959,3.044,6.393,6.393,0,0,1-2.742,2.1,10.434,10.434,0,0,1-4.155.765A10.983,10.983,0,0,1,323.925,70.852Z"
                                transform="translate(-176.046 -43.604)" />
                            <path d="M361.76,63.175H348.312a4.067,4.067,0,0,0,1.161,2.767A3.547,3.547,0,0,0,352,66.9a3.125,3.125,0,0,0,3.095-1.875h6.316a8.641,8.641,0,0,1-1.758,3.44,8.883,8.883,0,0,1-3.179,2.4,10.18,10.18,0,0,1-4.272.866,10.329,10.329,0,0,1-5.071-1.219,8.631,8.631,0,0,1-3.473-3.473,11.828,11.828,0,0,1-.017-10.563A8.54,8.54,0,0,1,347.093,53a11.258,11.258,0,0,1,10.109-.042,8.469,8.469,0,0,1,3.423,3.372,10.2,10.2,0,0,1,1.236,5.1A15.547,15.547,0,0,1,361.76,63.175Zm-5.979-3.3a3.037,3.037,0,0,0-1.043-2.43,3.826,3.826,0,0,0-2.607-.9,3.784,3.784,0,0,0-2.523.866,3.869,3.869,0,0,0-1.27,2.464Z"
                                transform="translate(-179.685 -43.606)" />
                        </g>
                    </svg>
                </Link>
                <ButtonLink href="/create" className="bg-popadvise text-white font-medium md:text-xl mb-4 md:mb-6 py-6">
                    EMPIEZA AHORA
                </ButtonLink>
                <p className="mb-4 md:mb-6 text-sm md:text-base font-normal">Creamos experiencias digitales únicas para nuestros clientes en Mexico y Latam.</p>
                <h4 className="mb-4 md:mb-6 text-sm md:text-base font-normal">LEGAL</h4>
                <div className="flex gap-2 md:gap-4 mb-3 text-xs md:text-base">
                    <Link prefetch={false} href="/privacy" className="underline text-[#898989]">Politica de privacidad</Link>
                    <Link prefetch={false} href="/terms" className="underline text-[#898989]">Terminos y condiciones</Link>
                    <br />
                </div>
                <p className="text-[#898989] mb-16 text-xs md:text-base">
                    © {date.getFullYear()} Copyright - Todos los derechos reservados.
                </p>
                <h4 className="mb-6">SOCIAL</h4>
                <div className="flex items-center gap-8 text-[#898989]">
                    {
                        brand.socials.youtube && (
                            <a href={brand.socials.youtube} target="_blank" rel="noopener noreferrer">
                                <YoutubeIcon />
                            </a>
                        )
                    }
                    {
                        brand.socials.x && (
                            <a href={brand.socials.x} target="_blank" rel="noopener noreferrer">
                                <XIcon />
                            </a>
                        )
                    }
                    {
                        brand.socials.facebook && (
                            <a href={brand.socials.facebook} target="_blank" rel="noopener noreferrer">
                                <FacebookIcon />
                            </a>
                        )
                    }
                    {
                        brand.socials.instagram && (
                            <a href={brand.socials.instagram} target="_blank" rel="noopener noreferrer">
                                <InstagramIcon />
                            </a>
                        )
                    }
                    {
                        brand.socials.tiktok && (
                            <a href={brand.socials.tiktok} target="_blank" rel="noopener noreferrer">
                                <TikTokIcon />
                            </a>
                        )
                    }
                </div>
            </div>
        </section>
    )
}

export const YoutubeIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="17"
        fill="currentColor"
        viewBox="0 0 23 17"
    >
        <g clipPath="url(#clip0_117_12189)">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M21.4 2.511c.468.605.771 1.322.88 2.08q.205 1.692.22 3.396v1.588a30 30 0 0 1-.22 3.409 4.4 4.4 0 0 1-.88 2.08 3.23 3.23 0 0 1-2.2.885c-3.08.222-7.7.222-7.7.222s-5.72 0-7.456-.21a3.83 3.83 0 0 1-2.444-.898 4.4 4.4 0 0 1-.88-2.092A30 30 0 0 1 .5 9.575V7.987q.015-1.71.22-3.408a4.4 4.4 0 0 1 .88-2.08 3.23 3.23 0 0 1 2.2-.886c3.08-.21 7.7-.21 7.7-.21s4.62 0 7.7.222a3.23 3.23 0 0 1 2.2.886m-5.011 6.277L9.056 5.096v7.385z"
                clipRule="evenodd"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_117_12189">
                <path fill="#fff" d="M.5.25h22v16H.5z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const XIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="21"
        fill="currentColor"
        viewBox="0 0 23 21"
    >
        <g clipPath="url(#clip0_117_12187)">
            <path
                fill="currentColor"
                d="M17.537.646h3.186l-6.96 8.136 8.188 11.072h-6.412l-5.022-6.715-5.746 6.715H1.583l7.445-8.703L1.173.646h6.574l4.54 6.138zm-1.119 17.258h1.766L6.788 2.494H4.893z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_117_12187">
                <path fill="#fff" d="M.5.25h22v20H.5z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const FacebookIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        viewBox="0 0 25 25"
    >
        <g clipPath="url(#clip0_117_12185)">
            <path
                fill="currentColor"
                d="M24.5 12.844c0-2.178-.658-4.311-1.894-6.146-1.237-1.835-3-3.294-5.084-4.206a12.57 12.57 0 0 0-6.668-.939 12.3 12.3 0 0 0-6.149 2.625 11.37 11.37 0 0 0-3.689 5.36 10.85 10.85 0 0 0-.065 6.404 11.34 11.34 0 0 0 3.58 5.426 12.3 12.3 0 0 0 6.094 2.737V16.14H7.578v-3.296h3.047v-2.512c0-2.856 1.792-4.435 4.532-4.435q1.352.018 2.687.222v2.806H16.33a1.8 1.8 0 0 0-1.282.325 1.63 1.63 0 0 0-.665 1.09q-.026.183-.008.367v2.137H17.7l-.532 3.296h-2.8v7.965c2.824-.422 5.396-1.79 7.254-3.854S24.5 15.56 24.5 12.844"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_117_12185">
                <path fill="#fff" d="M.5.25h24v24H.5z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const InstagramIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="25"
        fill="currentColor"
        viewBox="0 0 23 25"
    >
        <g
            fill="currentColor"
            fillRule="evenodd"
            clipPath="url(#clip0_117_12181)"
            clipRule="evenodd"
        >
            <path d="M6.966 1.502C8.139 1.44 8.518 1.44 11.5 1.44s3.361 0 4.547.063c.91.02 1.811.2 2.664.53 1.472.603 2.63 1.818 3.19 3.348.32.881.494 1.812.513 2.753.062 1.212.062 1.604.062 4.686 0 1.878-.023 2.739-.04 3.41-.012.43-.022.782-.022 1.275a8.6 8.6 0 0 1-.513 2.754c-.571 1.525-1.738 2.73-3.214 3.321a7.9 7.9 0 0 1-2.665.53c-1.173.064-1.552.064-4.534.064-1.818 0-2.65-.024-3.3-.042a40 40 0 0 0-1.235-.021c-.91-.02-1.811-.2-2.664-.53-1.479-.594-2.646-1.805-3.215-3.335a8.6 8.6 0 0 1-.513-2.753C.5 16.279.5 15.888.5 12.806s0-3.473.061-4.698c.02-.941.193-1.872.513-2.754.574-1.528 1.746-2.734 3.227-3.321a7.9 7.9 0 0 1 2.665-.53M15.95 3.55c-1.161-.063-1.516-.063-4.45-.063v.025c-1.809 0-2.636.024-3.274.042-.4.012-.726.021-1.174.021a6 6 0 0 0-2.041.392A3.73 3.73 0 0 0 2.945 6.1a6.5 6.5 0 0 0-.379 2.11c-.06 1.2-.06 1.553-.06 4.597 0 1.87.022 2.724.04 3.383.011.414.02.751.02 1.214.01.72.137 1.433.38 2.11a3.73 3.73 0 0 0 2.065 2.133c.654.25 1.344.383 2.04.392 1.162.063 1.504.063 4.45.063 1.81 0 2.636-.024 3.274-.042.4-.012.727-.021 1.175-.021a5.9 5.9 0 0 0 2.04-.392 3.73 3.73 0 0 0 2.066-2.134c.242-.676.37-1.389.38-2.11.06-1.199.06-1.553.06-4.596 0-1.87-.023-2.725-.04-3.384-.012-.414-.02-.75-.02-1.214a6.5 6.5 0 0 0-.38-2.109 3.73 3.73 0 0 0-2.065-2.134 6 6 0 0 0-2.041-.417"></path>
            <path d="M5.852 12.805c0-3.222 2.528-5.835 5.646-5.835 1.498 0 2.934.615 3.993 1.71a5.94 5.94 0 0 1 1.654 4.125c0 3.223-2.528 5.835-5.647 5.835-3.118 0-5.646-2.612-5.646-5.835m1.98.001c0 2.093 1.643 3.79 3.668 3.79.972 0 1.905-.4 2.592-1.11a3.86 3.86 0 0 0 1.074-2.68c0-2.092-1.641-3.79-3.666-3.79s-3.667 1.697-3.667 3.79M17.365 8.11c.729 0 1.32-.61 1.32-1.364s-.591-1.364-1.32-1.364-1.32.61-1.32 1.364c0 .753.59 1.364 1.32 1.364"></path>
        </g>
        <defs>
            <clipPath id="clip0_117_12181">
                <path fill="#fff" d="M.5.25h22v24H.5z"></path>
            </clipPath>
        </defs>
    </svg>
)

export const TikTokIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="27"
        fill="currentColor"
        viewBox="0 0 26 27"
    >
        <path
            fill="currentColor"
            d="M10.88 10.969v3.802a3.1 3.1 0 0 0-1.421-.05 3.16 3.16 0 0 0-1.302.587 3.3 3.3 0 0 0-.928 1.11c-.225.438-.352.922-.372 1.416-.026.425.036.852.183 1.25a3 3 0 0 0 .668 1.062c.294.3.646.533 1.034.68.388.15.802.21 1.215.18 2.29 0 3.099-1.659 3.099-3.215V2.731H16.7c.62 3.977 2.548 4.9 5.132 5.326v3.81s-3.065-.224-5.028-1.75v7.527c-.002 3.406-1.96 7.208-6.821 7.208-4.51 0-6.818-3.94-6.818-7.244.029-.978.258-1.94.674-2.82a6.9 6.9 0 0 1 1.736-2.287 6.65 6.65 0 0 1 2.492-1.352 6.5 6.5 0 0 1 2.812-.18"
        ></path>
    </svg>
);